import _objectSpread from "@babel/runtime/helpers/objectSpread2";
// @ts-nocheck
var PREFIX = 'SNACKBAR_';
export var SNACKBAR_ACTIONS = {
  SET_MESSAGE: /*#__PURE__*/"".concat(PREFIX, "SET_MESSAGE"),
  SHOW: /*#__PURE__*/"".concat(PREFIX, "SHOW")
};
export var snackbarReducer = function snackbarReducer(state, action) {
  switch (action.type) {
    case SNACKBAR_ACTIONS.SET_MESSAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        message: action.message
      });
    case SNACKBAR_ACTIONS.SHOW:
      return _objectSpread(_objectSpread({}, state), {}, {
        open: action.open
      });
    default:
      return state;
  }
};